import { useTransmit } from '../../../hooks';
import { ISubLink } from '../../../interfaces';
import { Link } from '../../atoms';
import styled from 'styled-components';

interface IProps {
  isBold?: boolean;
  subLink: ISubLink;
}

const NavSubMenuLink: React.FC<IProps> = ({ subLink, isBold }) => {
  const { leaveWithTicket } = useTransmit();

  const StyledSubLink = styled(Link)`
    display: block;
    font-size: 15px;
    padding: 8px;
    font-weight: ${isBold ? 'bold' : 100};
    width: 100%;
    :hover {
      background-color: #e7f6fd;
    }
  `;

  if (subLink.transmitdestination) {
    return (
      <StyledSubLink
        to={subLink.link}
        text={subLink.title}
        onClick={() => {
          leaveWithTicket(
            { preventDefault: () => {} } as React.MouseEvent<
              Element,
              MouseEvent
            >,
            subLink.link
          );
        }}
      />
    );
  }
  return <StyledSubLink to={subLink.link} text={subLink.title} />;
};

export default NavSubMenuLink;
